import { buildClinicalSubmitBody } from '../clinical/clinicalSubmitBody';
import type { SDIFormData } from '@odo/shared-ui/clinical/types';
import type { ClinicalEditArgs, ClinicalSubmitArgs } from '../clinical/clinicalWizardConfig';

export type SubmitSdiPayload = ClinicalSubmitArgs<SDIFormData>;

async function submitSdi(payload: SubmitSdiPayload): Promise<void> {
    const { default: apiV2 } = await import('../../../../api/v2');
    const { toApiError } = await import('../../../../services/apiErrors');
    const { uploadFinalPdf } = await import('../../../../services/clinicalDrafts');

    let sdiPdfFileId: string;
    try {
        sdiPdfFileId = await uploadFinalPdf(
            `/patients/${payload.patientId}/clinical/sdi/pdf/upload-url`,
            payload.mergedPdf,
            'sdi.pdf'
        );
    } catch (err) {
        throw toApiError(err);
    }

    const body = { sdiPdfFileId, ...buildClinicalSubmitBody(payload) };

    try {
        await apiV2.post(`/patients/${payload.patientId}/clinical/sdi`, body);
    } catch (err) {
        throw toApiError(err);
    }
}

export type EditSdiPayload = ClinicalEditArgs<SDIFormData>;

async function editSdi(payload: EditSdiPayload): Promise<void> {
    const { default: apiV2 } = await import('../../../../api/v2');
    const { toApiError } = await import('../../../../services/apiErrors');
    const { uploadFinalPdf } = await import('../../../../services/clinicalDrafts');

    let sdiPdfFileId: string;
    try {
        sdiPdfFileId = await uploadFinalPdf(
            `/patients/${payload.patientId}/clinical/sdi/pdf/upload-url`,
            payload.mergedPdf,
            'sdi.pdf'
        );
    } catch (err) {
        throw toApiError(err);
    }

    const body = { sdiPdfFileId, ...buildClinicalSubmitBody(payload) };

    try {
        await apiV2.put(`/patients/${payload.patientId}/clinical/sdi/${payload.eventId}`, body);
    } catch (err) {
        throw toApiError(err);
    }
}

export { submitSdi, editSdi };
